__turbopack_context__.v({
  "container": "RSVPPanel-module-scss-module__sx-EbG__container",
  "content": "RSVPPanel-module-scss-module__sx-EbG__content",
  "ctaButtonWrapper": "RSVPPanel-module-scss-module__sx-EbG__ctaButtonWrapper",
  "label": "RSVPPanel-module-scss-module__sx-EbG__label",
  "secondaryRSVPButton": "RSVPPanel-module-scss-module__sx-EbG__secondaryRSVPButton",
});
